/* eslint-disable @typescript-eslint/naming-convention */
export type PermissionMode = 'render' | 'disable' | 'hide' | 'message';
export type PermissionCheckType = 'all' | 'any';

export enum PERMISSION_MODE {
  render = 'render',
  disable = 'disable',
  hide = 'hide',
  message = 'message',
}
